export default {
  name: 'FormItem',
  data() {
    return {
      flag: true,
      inValue: '',
    };
  },
  props: ['filItem', 'params', 'form'],
  methods: {
    delectItem() {
      this.form.dispatch({ type: 'set', [this.params.field]: '' });
    },
  },
  created() {
    this.form.dispatch({
      type: 'add',
      [this.params.field]: {
        value: this.params.value,
        props: this.params.props,
        validate: this.params.validate,
        focusStatus: this.params.focusStatus,
        disabled: this.params.props.disabled,
      },
    });
  },
  watch: {
    inValue: {
      // 子组件数据拦截
      handler(val) {
        if (val === null) return;
        let value = '';
        // 字段为phone的时候特殊处理
        if (this.params.field === 'phone' && val) {
          value = val.replace(/\s/g, '');
        } else {
          value = val;
        }
        // 当数据变化的时候更新Store的状态
        this.form.dispatch({ type: 'set', [this.params.field]: value });
      },
    },
  },
  render(h) {
    return (
      <div>
        {h(this.filItem, {
          props: {
            ...this.params.props,
            form: this.form,
            params: {
              ...this.params,
              disabled: this.form && this.form.getCurrentState()[this.params.field].disabled,
              // 初始化的时候，获取页面配置默认的value
              initValue: this.form && this.form.getCurrentState()[this.params.field].value,
            },
            errorMessage:
              // 根据正则判断是否展示错误信息
              this.form && this.form.getCurrentState()[this.params.field].errorMessageList[0],
            allowClearHandler: this.delectItem,
          },
          on: {
            input: (e) => {
              this.inValue = e;
            },
          },
        })}
      </div>
    );
  },
};